import React, { useEffect, useRef, useState } from "react";
import { Table, Th, Button, Td, Tr, Count, ArrowButton, AddButton, ButtonPanel, Filter, Filters, ToggleContainer, ToggleInput, ToggleSlider, NoData, ScrollLayout, FilterBox, Actions, More, Status, ActionBox, IconBox, GroupHeader, ScrollContainerLayout, CasesContainer, CaseItem } from "./styles";
import { useDispatch, useSelector } from "react-redux";
import { RowContainer } from "../../styles/containers/styles";
import { AddIcon, ExcelIcon, FilterIcon, GetIcon, NextIcon, PreviousIcon, UploadIcon } from "../../../icons";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { deleteData, getData, postData, putData } from "../../../backend/api";
import CrudForm from "./create";
import { useTranslation } from "react-i18next";
import { addPageObject } from "../../../store/actions/pages";
import FormInput from "../input";
import Manage from "./manage";
import Loader from "../loader";
import Search from "../search";
import SubPage from "./subPage";
import DateRangeSelector from "../daterange";
import * as xlsx from "xlsx";
import { convertMinutesToHHMM } from "../../functions/minuteToHour";
import { dateFormat, dateTimeFormat, timeFormat } from "../../functions/date";
import { ToolTip } from "../../styles/list/styles";
import PopupView from "../popupview";
import { DisplayInformations } from "./popup";
import { Title } from "../../private/common/layout/header/styels";
import Drawer from "../drawer";
import Checkbox from "../checkbox";
import { ExportPopupContainer } from "../input/styles";
import NationalityChart from "../../private/pages/nationalities/chart";
import DynamicBarChart from "../chart";
import { FormViewer, ResponsesViewer } from "../../private/pages/forms/AddForm";
import moment from "moment";
import { fetchCompanyMenu } from "../../../store/actions/login";
import { decryptData, decryptEnvelope, exportPublicKeyToPEM, generateCompanyKeyPair, generateUserKeyPair, lockPrivateKeyInVault, unwrapSharedKey, wrapKeyForUser } from "../../functions/cryptoUtils";
import { useSecurity } from "../../../context/SecurityContext";
const ListTable = ({ dragList = false, profileImage, viewDetails = true, viewOnclick = true, formView = "normal", referenceId = 0, actions = [], api, setMessage, attributes = [], addPrivilege = true, delPrivilege = true, updatePrivilege = true,selectPrivilege=false ,shortName = "Item", itemTitle = "title", datefilter = false, bulkUplaod = false, pageKey = "", formMode = "single" , display=false, dataVal={},setRefreshVal,listHeadClass, moreOptions=false, reqDoc=false,popUpUsingId=false, cases=false, selectedDocsCategory=false,removeButtonPannel=false, chart="", page="",transformData, setSelectedCompany, refetchTableData}) => {
  const users = useSelector((state) =>
    state.pages[`${api}${referenceId === 0 ? "" : `/${referenceId}`}`]
      ? state.pages[`${api}${referenceId === 0 ? "" : `/${referenceId}`}`]
      : {
          data: null,
          isLoading: true,
          error: null,
        }
  );

  const user = useSelector((state) => state.login);

  const { i18n } = useTranslation();
  const [selectedLanguage] = useState(i18n.language || "de");
  let location = useLocation();
  const [showSublist, setShowSubList] = useState(false);
  const [currentApi] = useState(`${api}${referenceId === 0 ? "" : `/${referenceId}`}`);
  const [subAttributes, setSubAttributes] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentLimit, setCurrentLimit] = useState(15);
  const [count, setCount] = useState(0);
  const [showBulkUplad, setShowBulkUplad] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const [selectedValue, setSelectedValue] = useState({});

  const [groupedData, setGroupedData] = useState(null);
  const themeColors = useSelector((state) => state.themeColors);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [t] = useTranslation();
  
  const [showLoader, setShowLoader] = useState(false);
  const [currentAction, setCurrentAction] = useState("");
  const [showDetails, setShowDetails] = useState(false);
  const [openData, setOpenData] = useState(false);
  const [pageLimitFilter] = useState({
    type: "select",
    placeholder: "pageLimitFilter",
    name: "pageLimitFilter",
    validation: "",
    default: "",
    label: "",
    required: false,
    view: false,
    tag: true,
    add: true,
    update: true,
    apiType: "JSON",
    selectApi: [
      { id: 15, value: "15" },
      { id: 25, value: "25" },
      { id: 50, value: "50" },
      { id: 75, value: "50" },
      { id: 100, value: "50" },
      { id: 0, value: t("all") },
    ],
  });
  /**
   * Function to set the showLoader state.
   * @param {boolean} status The status of the loader.
   */
  const setLoaderBox = (status) => {
    setShowLoader(status);
  };
  // processing attributes
  const [initialized, setInitialized] = useState(false);
  const [prevCrud, setPrevCrud] = useState("");
  const [formInput, setFormInput] = useState([]);
  const [errroInput, setErrorInput] = useState([]);
  const [addValues, setAddValues] = useState({});
  const [updateId, setUpdateId] = useState("");
  const [updateValues, setUpdateValues] = useState({});
  const [udpateView, setUpdateView] = useState(() => {});
  const [filterView, setFilterView] = useState({});
  const [data, setData] = useState(null);
  const [enabledInAktCategory, setEnabledInAktCategory] = useState(true);
  const { userPrivateKey } = useSecurity();

  useEffect(() => {
    const addValuesTemp = {
      addValues: {},
      updateValues: {},
      viewValues: {},
      errorValues: {},
      filterValues: {},
    };
    let tempFilter = false;
    let date = new Date();

    attributes.forEach((item) => {
      if (item.type === "checkbox") {
        let bool = JSON.parse(item.default === "false" || item.default === "true" ? item.default : "false");
        if (item.add) {
          addValuesTemp.addValues[item.name] = bool;
        }
        addValuesTemp.updateValues[item.name] = bool;
      } else if (item.type === "multiSelect") {
        addValuesTemp.addValues[item.name] = [];
        addValuesTemp.errorValues[item.name] = [];
      } else if (item.type === "datetime" || item.type === "date" || item.type === "time") {
        if (item.default === "0") {
          // Set hour to 00:00
          date.setUTCHours(0, 0, 0, 0);
          addValuesTemp.updateValues[item.name] = date.toISOString();
        } else if (item.default === "1") {
          // Set hour to 23:59
          date.setUTCHours(23, 59, 0, 0);
          addValuesTemp.updateValues[item.name] = date.toISOString();
        } else {
          // Set hour to current time
          addValuesTemp.updateValues[item.name] = date.toISOString();
        }
        if (item.add) {
          addValuesTemp.addValues[item.name] = item.default === "empty" ? "" : date.toISOString();
        }
      } else if (item.type === "image" || item.type === "file") {
        if (item.add) {
          addValuesTemp.addValues[item.name] = "";
          addValuesTemp.addValues["selected_" + item.name] = [];
        }
        addValuesTemp.updateValues[item.name] = "";
        addValuesTemp.updateValues["selected_" + item.name] = [];
      } else {
        if (item.add) {
          addValuesTemp.addValues[item.name] = item.default;
        }
        addValuesTemp.updateValues[item.name] = item.default;
        if (item.type === "select" && item.filter) {
          if ((item.filterType ?? "multiSelect") === "multiSelect") {
            addValuesTemp.filterValues[item.name] = item.default?.length > 0 ? [item.default] : [];
          } else {
            addValuesTemp.filterValues[item.name] = item.default;
          }
          tempFilter = true;
        }
      }
      addValuesTemp.errorValues[item.name] = "";
      addValuesTemp.filterValues["searchkey"] = "";
    });
    setFormInput(attributes);
    setAddValues(addValuesTemp.addValues);
    setErrorInput(addValuesTemp.errorValues);
    setUpdateValues(addValuesTemp.updateValues);
    setFilterView(addValuesTemp.filterValues);
    setFilter(tempFilter);
    setInitialized(true);
  }, [attributes, dispatch]);

  // Helper to fetch vault (Move this outside useEffect or useCallback)
  // WARNING: Ensure 'getData' does NOT update 'users' Redux state, 
  // or this will cause an infinite loop.
  const getCompanyVault = async (companyId) => {
    try {
      const myVaultsRes = await getData({ company: companyId }, "vault/my-keys", dispatch, navigate);
      return myVaultsRes?.data?.vault?.find(v => v.company_id.toString() === companyId);
    } catch (error) {
      console.error("Vault fetch error:", error);
      return null;
    }
  };

  useEffect(() => {
    // 1. Loader Sync
    setLoaderBox(users.isLoading);

    // 2. Handle Counts (Sync)
    if (currentIndex === 0 && users.data?.count) {
      setCount(users.data.count);
    }

    // 3. Handle Grouped Data (Sync)
    if (currentIndex === 0 && users.data?.groupedData) {
      console.log(users.data.groupedData);
      if (chart) {
        let temp = [];
        users.data.groupedData.forEach((item) => {
          item.items.forEach((data) => {
            temp.push({ ...data });
          });
        });
        setData(temp);
        setGroupedData([]);
      } else {
        setGroupedData(users.data.groupedData ?? []);
        setCount(0);
      }
      return; // STOP here if we handled grouped data
    }

    // 4. Handle List Data (Async Decryption vs Sync Normal)
    const processListData = async () => {
      // Safety check
      if (!users.data?.data || !Array.isArray(users.data.data) || users.data.data.length === 0) {
        return;
      }

      // CASE A: Decryption Required
      if (shortName === "caseReports") {
        try {
          setLoaderBox(true);
          // Fix 1: Await the vault fetch
          // Note: using 'users.data.user' assuming the typo in your code was meant to be 'users'
          const companyId = user.data?.user?.company; 
          
          if(!companyId) throw new Error("No company ID found");

          if(!userPrivateKey) return;

          const myVault = await getCompanyVault(companyId);

          if (!myVault) {
             console.error("Security Error: No Vault found for this company.");
             return;
          }

          // Fix 2: Await the decryption of ALL items
          // Assuming 'userPrivateKey' is available in your component scope
          const decryptedList = await Promise.all(
            users.data.data.map((item) => decryptCaseWithCompanyKey(userPrivateKey, myVault, item))
          );

          setData(decryptedList);

        } catch (err) {
          console.error("Processing Error:", err);
          // Optional: setData([]) or show error
        } finally {
          setLoaderBox(false);
        }
      } 
      // CASE B: Normal Data (No Decryption)
      else {
        setData(users.data.data);
      }
    };

    // Execute the async function
    if (users.data?.data && !users.data.groupedData) {
      processListData();
    }

  }, [users, currentIndex, userPrivateKey]); // Added shortName to dependencies

  const decryptCaseWithCompanyKey = async (myPrivateKey, myKeyVault, caseData) => {
    try {
      // =========================================================
      // STEP 2: Unwrap the Company Private Key
      // =========================================================
      // The Company Key is stored in the KeyVault, encrypted specifically for ME.
      const companyPrivateKey = await unwrapSharedKey(
        myKeyVault.encrypted_company_private_key, // The hidden Company Key
        myKeyVault.encrypted_aes_key,             // The wrapper key
        myKeyVault.encryption_iv,                 // The IV
        myPrivateKey                              // My key unlocks the wrapper
      );

      // =========================================================
      // STEP 3: Unlock the Case AES Key ("The Blue Key")
      // =========================================================
      // We use the Company Private Key to open the "company_lock" on the case.
      const caseAesKey = await decryptEnvelope(
        caseData.keys.company_lock, 
        companyPrivateKey
      );

      // =========================================================
      // STEP 4: Decrypt the Actual Data
      // =========================================================
      // Now we use the Case AES Key to turn the strings back to text.
      // (Assuming you stored them as single strings using encryptData)
      const title = caseData.title ? await decryptData(caseData.title, caseAesKey) : "";
      const description = caseData.description ? await decryptData(caseData.description, caseAesKey) : "";
      const whistleblowerName = caseData.whistleblowerName ? await decryptData(caseData.whistleblowerName, caseAesKey) : "";
      const whistleblowerMobileNumber = caseData.whistleblowerMobileNumber ? await decryptData(caseData.whistleblowerMobileNumber, caseAesKey) : "";
      const whistleblowerEmail = caseData.whistleblowerEmail ? await decryptData(caseData.whistleblowerEmail, caseAesKey) : "";

      const customFields = (caseData.customFields && Array.isArray(caseData.customFields) && caseData.customFields.length > 0) ? await Promise.all(caseData.customFields.map(async (item) => {
        if(item.isEncrypted && item.encryptedValue){
          return {
            ...item,
            value: await decryptData(item.encryptedValue, caseAesKey)
          }
        }
        return item;
      })) : [];

      return {
        ...caseData,
        title,
        description,
        whistleblowerName,
        whistleblowerMobileNumber,
        whistleblowerEmail,
        caseAesKey,
        customFields
      };

    } catch (error) {
      console.error("Decryption failed:", error);
      throw new Error("Failed to decrypt. You might not have access or the password is wrong.");
    }
  }

  useEffect(() => {
    if (initialized) {
      if(selectedDocsCategory){
        let payload = {...filterView, folderType: selectedDocsCategory}
        dispatch(addPageObject(currentApi, currentIndex, currentLimit, payload, navigate));
      }
      else{
        dispatch(addPageObject(currentApi, currentIndex, currentLimit, filterView, navigate));
      }
    }
  }, [initialized, currentApi, currentIndex, currentLimit, dispatch, filterView, navigate, selectedDocsCategory, refetchTableData]);
  const refreshView = (currentIndex) => {
    try {
      if(selectedDocsCategory){
        let payload = {...filterView, folderType: selectedDocsCategory}
        dispatch(addPageObject(currentApi, currentIndex, currentLimit, payload, navigate));
      }
      else{
        dispatch(addPageObject(currentApi, currentIndex, currentLimit, filterView, navigate));
      }
    } catch {}
  };
  const toExcel = (currentIndex) => {
    try {
      exportToExcel();
    } catch (error) {
      console.log(error);
    }
  };
  //crud functions
  const [isCreating, setIsCreating] = useState(false);
  const isCreatingHandler = (value, callback) => {
    if (isCreating) {
      setUpdateView(() => callback);
      setIsCreating(false);
      navigate({}, "", window.location.pathname);
    } else {
      formInput.forEach((item) => {
        if (item.add) {
          if((shortName==="whistleCategory") && user.data?.user?.authorisation?.toLowerCase()==="admin"){
            item["disabled"] = false;
          }
        }
      });

      if (
        shortName === "whistleCategory" &&
        formInput.find((item) => item.name === "isActive") &&
        user.data?.user?.authorisation?.toLowerCase() === "admin"
      ) {
        let index = formInput.findIndex((item) => item.name === "isActive");
        if (index !== -1) {
          formInput[index].add = false; // Update the item instead of removing it
        }
      }

      window.location.hash = "add";
      setIsCreating(true);
    }
  };

  const [isEditing, setIsEditing] = useState(false);
  const isEditingHandler = (value, callback) => {
    setLoaderBox(true);
    if (!isEditing) {
      setUpdateView(() => callback);
      const updateValues = {};
      setUpdateId(value?._id);
      formInput.forEach((item) => {
        if (item.update) {
          
          if((shortName==="whistleCategory") && user.data?.user?.authorisation?.toLowerCase()==="admin" && value?.isMasterData){
            item["disabled"] = true;
          } else if((shortName==="whistleCategory") && user.data?.user?.authorisation?.toLowerCase()==="admin"){
            item["disabled"] = false;
          }

          if (item.type === "checkbox") {
            let bool = value[item.name] ? (value[item.name].toString() === "true" ? true : false) : false;
            updateValues[item.name] = bool;
          } else if (item.type === "number") {
            let bool = parseInt(value[item.name]);
            updateValues[item.name] = bool;
          } else if (item.type === "select") {
            updateValues[item.name] = typeof value[item.name] === "undefined" ? "" : typeof value[item.name] === "string" || typeof value[item.name] === "number" ? value[item.name] : value[item.name]?._id ? value[item.name]._id : "";
            if((item.name==="authorisation" || item.label==="permissions") && shortName==="user"){
              updateValues.permissions = value.permissions || null;
            }
          } else if (item.type === "multiSelect") {
            updateValues[item.name] = Array.isArray(value[item.name]) ? value[item.name] : [];
          } else if (item.type === "image") {
            updateValues["selected_" + item.name] = [];
            updateValues[item.name] = value[item.name] ? value[item.name] : "";
          } else {
            updateValues[item.name] = (value && value[item.name]) ? value[item.name] : "";
          }
        }
      });

      if((shortName==="whistleCategory") && value?.isMasterData && attributes.find((item)=> item.name==="isActive")===undefined){
        formInput.push(
          {
            type: "checkbox",
            placeholder: "active",
            name: "isActive",
            validation: "",
            showItem: "",
            default: "true",
            label: "active",
            required: false,
            view: true,
            tag: true,
            add: true,
            update: true,
            filter: false,
          }
        )
      }

      if(!(value?.isMasterData) && (shortName==="whistleCategory") && user.data?.user?.authorisation?.toLowerCase()==="admin"){
        let index = formInput.findIndex((item)=> item.name==="isActive")
        if(index!==-1)
          formInput[index].update = false;
      } else if((value?.isMasterData) && (shortName==="whistleCategory") && user.data?.user?.authorisation?.toLowerCase()==="admin"){
        let index = formInput.findIndex((item)=> item.name==="isActive")
        if(index!==-1)
          formInput[index].update = true;
      }

      setUpdateValues(updateValues);
      if(shortName!=="caseReports"){
        setIsEditing(true);
        window.location.hash = "edit";
      }
    } else {
      setUpdateId("");
      navigate({}, "", window.location.pathname);
      setIsEditing(false);
    }
    setLoaderBox(false);
  };
  const deleteHandler = async (item, id = "") => {
    await deleteData({}, (currentApi==="equipments" || currentApi==="files") ? `${currentApi}/${item.user}` : currentApi, id, dispatch, navigate)
      .then((response) => {
        if (response.status === 200) {
          setMessage({ type: 1, content: t("deleted", { shortName: (t(item.title ? item.title : shortName)==="Abwesenheiten" && window.location.pathname==="/settings") ? "Abwesenheit" : t(shortName) }), proceed: t("okay"), code: 200 });
          setCount((count) => count - 1);
          setIsCreating(false);
          setIsEditing(false);
          refreshView();
          // udpateView(0);
        } else if (response.status === 404) {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 404 });
        } else {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 500 });
        }
        setLoaderBox(false);
      })
      .catch((error) => {
        setMessage({ type: 1, content: error.message + "Something went wrong!", proceed: "Okay", code: 500 });
        setLoaderBox(false);
      });
  };
  const [action, setActions] = useState([]);
  const openAction = (item, data) => {
    // Actions Window
    setActions({ item, data });
    // setMessage({ type: 1, content: item.title + " / " + data._id, proceed: "Okay" });
  };
  const submitHandler = async (data) => {
    setLoaderBox(true);

    try {
      let securityPayload = {};

      // =========================================================
      // SCENARIO 1: COMPANY CREATION (Advisor creating new Company)
      // =========================================================
      if (currentApi === "company") {
        
        // 1. Generate NEW Identity for this Company
        const keyPair = await generateCompanyKeyPair();
        const companyPublicKeyPEM = await exportPublicKeyToPEM(keyPair.publicKey);
        const companyPrivateKey = keyPair.privateKey; // RAW Object

        const vaults = [];

        // B. Vault for ME (The Advisor creating it)
        // FIX: Use my PUBLIC Key (from Redux), not my Private Key (from Session)
        const myPublicKey = user?.data?.user?.public_key; // Ensure this exists in your Redux User state
        
        if (myPublicKey) {
          const myVault = await wrapKeyForUser(companyPrivateKey, myPublicKey);
          vaults.push({
            user_type: "existing_user",
            user_id: user.data.user._id,
            encrypted_private_key: myVault.encrypted_secret,
            encrypted_key: myVault.encrypted_key,
            iv: myVault.iv,
            algo: "RSA-OAEP"
          });
        }

        // C. Vaults for OTHER Advisors (Selected in dropdown)
        if (Array.isArray(data.advisor) && data.advisor.length > 0) {
          // Fetch Public Keys for these advisors
          const response = await getData({ userIds: data.advisor }, "user/public-keys", dispatch, navigate);
          
          if (response?.data?.users) {
            for (const advisor of response.data.users) {
              if (advisor.public_key && myPublicKey !== advisor.public_key) {
                const advisorVault = await wrapKeyForUser(companyPrivateKey, advisor.public_key);
                vaults.push({
                  user_type: "existing_user",
                  user_id: advisor._id,
                  encrypted_private_key: advisorVault.encrypted_secret,
                  encrypted_key: advisorVault.encrypted_key,
                  iv: advisorVault.iv,
                  algo: "RSA-OAEP"
                });
              }
            }
          }
        }

        // =========================================================
        // NEW: CREATE VAULT 2 (Server Recovery Vault)
        // =========================================================

        // A. Fetch Server Public Key (You need an API endpoint for this)
        const serverConfig = await getData({}, "security/server-key", dispatch, navigate);
        const serverPublicKeyPEM = serverConfig.data.publicKey;

        // B. Encrypt Company Key with Server Public Key
        // We use the same 'wrapKeyForUser' helper because it handles Hybrid Encryption perfectly.
        const recoveryVault = await wrapKeyForUser(companyPrivateKey, serverPublicKeyPEM);

        // Attach to payload
        securityPayload = {
          security_config: {
            public_key: companyPublicKeyPEM,
            initial_vaults: vaults,
            // The Safety Net
            recovery_vault: {
              encrypted_secret: recoveryVault.encrypted_secret,
              encrypted_key: recoveryVault.encrypted_key,
              iv: recoveryVault.iv
            }
          }
        };
      }

      // =========================================================
      // SUBMISSION
      // =========================================================
      const finalPayload = { ...data, ...securityPayload };
      
      // ... (Rest of your submission logic remains the same) ...
      const endpoint = currentApi === "leave-request" 
          ? "user/addAbsence" 
          : (currentApi === "equipments" || currentApi === "files") 
            ? `${currentApi}/${data.user}` 
            : currentApi;

      const response = await postData(finalPayload, endpoint, dispatch, navigate);

      if (response.status === 200 || response.status === 201) {
          setMessage({ type: 1, content: t("saved", { shortName: t(shortName) }), proceed: "Okay", code: 200 });
          setIsCreating(false);
          if (setRefreshVal) setRefreshVal(true);
          refreshView();
      } else {
          setMessage({ type: 1, content: t(response.data?.message || "Error"), proceed: "Okay", code: response.status });
      }

    } catch (error) {
      console.error("Security Error:", error);
      setMessage({ type: 1, content: error.message || "Security processing failed", proceed: "Okay", code: 500 });
    } finally {
      setLoaderBox(false);
    }
  };

  const updateHandler = async (data) => {
    try {
      setLoaderBox(true);
      let payload = { ...data };
      attributes
        .filter((attribute) => attribute.type === "multiSelect")
        .forEach((item) => {
          if (Array.isArray(payload[item.name]) && payload[item.name].length > 0) {
            payload[item.name] = payload[item.name].map((value) =>
              typeof value === "object" && value._id ? value._id : value
            );
          }
          
        });

      await putData(payload, `${currentApi==="leave-request" ? "user/addAbsence" : (currentApi==="equipments" || currentApi==="files") ? `${currentApi}/${data.user}`  : currentApi}/${updateId}`, dispatch, navigate)
        .then((response) => {
          if (response.status === 200) {
            setMessage({ type: 1, content: t("updated", { shortName: (t(shortName)==="Abwesenheiten" && window.location.pathname==="/settings") ? "Abwesenheit" : t(shortName) }), proceed: "Okay", code: 200 });
            refreshView(currentIndex);
            if(setRefreshVal)
              setRefreshVal(true);
            setIsEditing(false);
          } else if (response.status === 404) {
            setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 404 });
          } else {
            setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 500 });
          }
          setLoaderBox(false);
        })
        .catch((error) => {
          alert(error);
          setLoaderBox(false);
        });
    } catch (error) {
      console.error(error);
    }
  };

  const filterChange = (sl, option, name) => {
    let items = filterView[name];
    if (Array.isArray(items)) {
      const index = items.findIndex((item) => item === option.id);
      if (index === -1) {
        // If option._id doesn't exist, push it to the items array
        items.push(option.id);
      } else {
        // If option._id already exists, remove it from the items array
        items.splice(index, 1);
      }
      const updateValue = {
        ...filterView,
        [name]: items,
      };
      console.log(updateValue);
      setFilterView(updateValue);
    } else {
      const updateValue = {
        ...filterView,
        [name]: option.id,
      };
      console.log(updateValue);
      setFilterView(updateValue);
    }
  };

  const pageLimitFilterChange = (option, name) => {
    setCurrentLimit(option.id);
  };
  const dateRangeChange = (item) => {
    const startDate = new Date(item.startDate);
    startDate.setHours(0, 0, 0, 0); // Set start date to 00:00

    const endDate = new Date(item.endDate);
    endDate.setHours(23, 59, 59, 999); // Set end date to 23:59
    const udpateValue = {
      ...filterView,
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
    };
    // updating the formm values
    setFilterView(udpateValue);
  };
  const closeManage = () => {
    setActions([]);
  };

  //export to excel
  const exportToExcel = () => {
  // JSON data to be converted to Excel
  const jsonData = Object.values(selectedValue).some(value => value) ? groupedData?.length > 0 ? groupedData.filter(item => selectedValue[item._id]) : data.filter(item => selectedValue[item._id])
    : groupedData?.length > 0 ? groupedData : data;
    console.log("jsonData", jsonData);
  if (jsonData) {
    // Convert JSON to worksheet
    const excelData = [];
    let secondExcelData = [];
    let userId = "";

    jsonData.forEach((data) => {
      const excelRow = {};

      attributes.forEach((attribute) => {
        if (
          (selectPrivilege
            ? attribute.view && exportAttributes[attribute.name] && exportAttributes[attribute.name] === true
            : attribute.view)
        ) {
          const name = t(attribute.label);
          if (attribute.collection?.length > 0 && attribute.showItem?.length > 0) {
            return (excelRow[name] = attribute.showItem==="locale" ? data[attribute.collection][sessionStorage.getItem("_lang") ?? "de"] : data[attribute.collection][attribute.showItem] ?? "No Data");
          } else {
            switch (attribute.type) {
              case "view":
                return (excelRow[name] = data[attribute.collection][attribute.showItem] ?? "No Data");
              case "minute":
                return (excelRow[name] = convertMinutesToHHMM(parseFloat(data[attribute.name] ?? 0)));
              case "datetime":
                return (excelRow[name] = data[attribute.name] ? dateTimeFormat(data[attribute.name]) : "N/A");
              case "date":
                return (excelRow[name] = data[attribute.name] ? dateFormat(data[attribute.name]) : "N/A");
              case "time":
                return (excelRow[name] = data[attribute.name] ? timeFormat(data[attribute.name]) : "N/A");
              case "select":
                if (attribute.apiType === "JSON") {
                  return (excelRow[name] = attribute.selectApi.filter((item) => item.id.toString() === data[attribute.name]?.toString()).map((filteredItem, index) => filteredItem.value)[0] ?? "");
                } else if (attribute.apiType === "CSV") {
                  return (excelRow[name] = data[attribute.name]);
                } else {
                  return (excelRow[name] = attribute.showItem === "locale" ? data[attribute.name]?.[sessionStorage.getItem("_lang") ?? "de"] : data[attribute.name]?.[attribute.showItem] ?? "Nil");
                }

              default:
                switch (typeof data[attribute.name]) {
                  case "undefined":
                    return (excelRow[name] = "Not Found");
                  case "object":
                    return (excelRow[name] = objectValueReturn(data, attribute));
                  case "boolean":
                    return (excelRow[name] = data[attribute.name].toString());
                  case "string":
                  case "number":
                  default:
                    if (attribute.type === "select" && attribute.apiType === "JSON") {
                      return attribute.selectApi.filter((item) => item.id.toString() === data[attribute.name]?.toString()).map((filteredItem) => (excelRow[name] = filteredItem.value));
                    } else {
                      return (excelRow[name] = data[attribute.name]?.toString().substring(0, 200));
                    }
                }
            }
          }
        }
      });

      if (pageKey === "page-report3") {
        if (userId !== data?._id?.user?._id) {
          if (userId !== "") {
            excelData.push({});
            excelData.push({});
            excelData.push({});
          }
        }
        userId = data?._id?.user?._id;
      }
      
      excelData.push(excelRow);
    });

    // --- MODIFICATION START ---
    if (shortName.includes("hours-recording")) {
    const summaryMap = jsonData.reduce((acc, data) => {
        const user = data.user;
        if (!user || !user._id) return acc;

        let key;
        let groupData = {};

        if (shortName === "hours-recording") {
            key = user._id;
        } else if (shortName === "hours-recording-locations") {
            key = `${user._id}-${user.location}`;
            groupData[t("location")] = user.location;
        } else if (shortName === "hours-recording-department") {
            key = `${user._id}-${user.department}`;
            groupData[t("department")] = user.department;
        } else if (shortName === "hours-recording-projects") {
            key = `${user._id}-${user.place}`;
            groupData[t("place")] = user.place;
        }

        // --- FIX START ---

        // 1. Initialize the user's summary row if it's the first time we see them
        if (!acc[key]) {
            acc[key] = {
                [t("firstName")]: user.firstName,
                [t("lastName")]: user.lastName,
                ...groupData,
                [t("totalHours")]: 0,
            };
        }

        // 2. Aggregate hours for EVERY record
        const hoursToAdd = parseFloat((data.workedHours ?? "0").replace(",", "."));
        acc[key][t("totalHours")] += hoursToAdd;

        // 3. Aggregate surcharges for EVERY record
        if (user.surcharge && Object.keys(user.surcharge).length > 0) {
            Object.entries(user.surcharge).forEach(([surchargeKey, surchargeValue]) => {
                const translatedKey = t(surchargeKey);
                // Initialize this specific surcharge on the summary row if it doesn't exist yet
                if (!acc[key][translatedKey]) {
                    acc[key][translatedKey] = 0;
                }
                // Add the surcharge value (assuming it's a number)
                acc[key][translatedKey] += parseFloat((surchargeValue ?? "0").replace(",", "."));
            });
        }
        
        // --- FIX END ---
        
        return acc;
    }, {});

    // Define keys that should NOT be formatted as numbers
    const nonNumericKeys = [
        t("firstName"),
        t("lastName"),
        t("location"),
        t("department"),
        t("place")
    ];

    console.log("summaryMap", summaryMap)

    // Format all numeric values (totalHours and all surcharges) back to a comma-string
    secondExcelData = Object.values(summaryMap).map(item => {
    // 1. First, format all numeric values into comma-strings
    const formattedItem = {};
    Object.keys(item).forEach(key => {
        if (!nonNumericKeys.includes(key)) {
            formattedItem[key] = (item[key] ?? 0).toFixed(2).replace(".", ",");
        } else {
            formattedItem[key] = item[key];
        }
    });

    // 2. Now, reorder the keys to move totalHours to the end
    const totalHoursKey = t("totalHours");
    const { [totalHoursKey]: totalHours, ...rest } = formattedItem; // Pull totalHours out
    const finalItem = { ...rest, [totalHoursKey]: totalHours };   // Add it back at the end

    return finalItem;
});
}
    // --- MODIFICATION END ---
    
    if (pageKey === "page-report3") {
      excelData.push({});
      excelData.push({});
      excelData.push({});
    }

    const worksheet = xlsx.utils.json_to_sheet(excelData);
    console.log("secondExcelData", secondExcelData)

    const workbook = xlsx.utils.book_new();
    if (shortName.includes("hours-recording")) {
      const secondWorksheet = xlsx.utils.json_to_sheet(secondExcelData);
      xlsx.utils.book_append_sheet(workbook, worksheet, t("list"));
      xlsx.utils.book_append_sheet(workbook, secondWorksheet, t("summary"));
    } else {
      xlsx.utils.book_append_sheet(workbook, worksheet, t("report"));
    }
    xlsx.writeFile(workbook, t(shortName) + "-data.xlsx");
  }
};

  const handleDragStart = (e, id, sequence) => {
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/plain", id + "-" + sequence);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
  };

  const handleDrop = async (e, index, sequence) => {
    e.preventDefault();

    // Retrieve the dragged data and split it
    let dataValue = e.dataTransfer.getData("text/plain");
    dataValue = dataValue.split("-");
    const draggedRowId = parseInt(dataValue[0]);
    // const draggedSequence = parseFloat(dataValue[1]);

    // Find the index of the dragged and dropped rows
    const lastRow = data[index - 1] ?? { sequence: 0 };
    const droppedRow = data[index];

    // Copy data to update it
    const updatedRows = [...data];

    // Remove the dragged row and get it
    const [draggedRow] = updatedRows.splice(draggedRowId, 1);
    updatedRows.splice(index, 0, draggedRow);
    // Update the sequence of the dragged row
    console.log(draggedRowId, index);

    updatedRows[index].sequence = lastRow.sequence ?? 0;
    updatedRows[index + 1].sequence = (lastRow.sequence ?? 0) + 0.001;

    // Insert the dragged row at the new position

    // Update the state with the modified data

    setData(updatedRows);
    await putData({ sequence: draggedRow.sequence }, `${api}/${draggedRow._id}`);
    await putData({ sequence: droppedRow.sequence }, `${api}/${droppedRow._id}`);
  };

  const objectValueReturn = (data, attribute) => {
    if (attribute.showItem && data[attribute.name]?.[attribute.showItem]) {
      return data[attribute.name][attribute.showItem];
    } 
    else if(attribute.showItem==="locale" && data[attribute.name]){
      return data[attribute.name][sessionStorage.getItem("_lang") ?? "de"];
    }
    else if (!attribute.showItem && data[attribute.name]) {
      if((attribute.name==="oldValue" || attribute.name==="newValue") && attribute.type==="mixed" && ["countryOfBirth", "country", "nationality", "workDays", "religion"].includes(data.fieldName)){
        return data[attribute.name][sessionStorage.getItem("_lang") ?? "de"];
      }
      // Check if the key of data matches specific known keys
      if (["countryOfBirth", "country", "nationality", "workDays", "religion"].includes(attribute.name)) {
        return data[attribute.name][sessionStorage.getItem("_lang") ?? "de"];
      } 
      else if (attribute.name === "company") {
        return data[attribute.name]?.organization;
      } 
      else if (attribute.name === "terminationBy") {
        return data[attribute.name]?.name;
      } 
      else {
        return data[attribute.name]?.title ?? "Nil";
      }
    } 
    else {
      return "Nil";
    }
  };
  

  useEffect(() => {
    if(display){
      setOpenData({ actions, attributes, data:dataVal });
      setSubAttributes({ actions, attributes, data:dataVal });
    }
  }, [display])

  const paramValue = searchParams.get('id');
  
  useEffect(() => {
    
      if (paramValue && data && data.length>0 && popUpUsingId) {
        setShowDetails(true);
        if(data?.find((val)=> val._id===paramValue)){
          shortName==="caseReports" && isEditingHandler(data?.find((val)=> val._id===paramValue), udpateView)
          setOpenData({ actions, attributes, data: data?.find((val)=> val._id===paramValue) });
          setSubAttributes({ actions, attributes, data: data?.find((val)=> val._id===paramValue) });
        }
        else{
          fetchParamsData({actions, attributes})
        }
      }
    }, [window.location.pathname, paramValue,data]);

    const fetchParamsData = async ({actions, attributes}) => {
      try {
        await getData({ id: paramValue }, currentApi, dispatch, navigate)
      .then((response) => {
        shortName==="caseReports" && isEditingHandler(response.data, udpateView)
        setOpenData({ actions, attributes, data: response.data });
          setSubAttributes({ actions, attributes, data: response.data });
      })
      .catch((error) => {
        console.log(error);
        shortName==="caseReports" && isEditingHandler({}, udpateView)
        setOpenData({ actions, attributes, data: {} });
          setSubAttributes({ actions, attributes, data:{} });
      });
      } catch (error) {
        console.log(error);
        
      }
    }

    const selectCompanyForAdvisor = (companyId) => {
      if(companyId && user.data?.user?.authorisation === "advisor" && user?.data?.user?.partner){
        dispatch(fetchCompanyMenu({company: companyId})).then((data) => {
          if(user.data?.user?.authorisation === "advisor" && window.location.pathname.startsWith("/partner/")){
            if(shortName==="caseReports") {
              navigate("/whistle");
            } else {
              navigate(data.menu[0]?.path || "/");
            }
            setSelectedCompany(companyId);
            sessionStorage.setItem("selected-company", companyId);
          }
        });
        
      }
    }

  //export to excel end
  const TableRowWithActions = ({ attributes, data, slNo, pinnedRows }) => {
    // data[attribute.name]?.title ? data[attribute.name]?.title : data[attribute.name]?.toString()
    const [isDragOver, setIsDragOver] = useState(false);

    selectRef.current[slNo] = useRef(null);
    let acctionCount = actions.filter((item) => item.element === "button" && item.type !== "subList").length;
    const openRowData = () => {
      if(!viewOnclick) return;
      
      if((shortName==="company" && window.location.pathname==="/partner/company") || (shortName==="caseReports" && window.location.pathname==="/partner/whistle")){
        if(data?.hasAccess===false && shortName ==="company"){
          setMessage({ type: 2, content: t("accessDeniedCompanyContent")});
          return;
        }
        setMessage({ type: 2, content: t("accessCompanyContent"), proceed: t("confirm"), onProceed: selectCompanyForAdvisor, data: shortName==="caseReports" ? data?.company?._id : data._id });
      } else {
        shortName==="caseReports" && isEditingHandler(data, udpateView)
        setShowDetails(true);
        setOpenData({ actions, attributes, data });
        setSubAttributes({ actions, attributes, data });
      }
    };
    return (
      <Tr
        draggable={dragList}
        onDragStart={
          dragList
            ? (e) => {
                handleDragStart(e, slNo, data.sequence ?? 0);
              }
            : null
        }
        isDragOver={isDragOver}
        onDragOver={
          dragList
            ? (e) => {
                handleDragOver(e);
                setIsDragOver(true);
              }
            : null
        }
        onDragLeave={() => {
          setIsDragOver(false);
        }}
        onDrop={dragList ? (e) => handleDrop(e, slNo, data.sequence ?? 0) : null}
        key={`${shortName}-${slNo}-${pinnedRows}`}
        className={`${pinnedRows ? "no-border pinned" : "no-border"} ${!!selectedValue[data._id] ? "selected" : ""} ${(shortName==="company" && user.data?.user?.authorisation === "advisor" && user?.data?.user?.partner && data?.hasAccess===false) ? "disabled-row" : ""}`}
      >
        {/* <td>{data.sequence}</td> */}
        {selectPrivilege && (<Td key={`actions-${shortName}-${data._id}-${slNo}`} style={{ zIndex: (pinnedRows === true ? count * 2 : count) + 100 - slNo }} className={`${!!selectedValue[data._id] ? "selected" : ""} actions`}>
          <ActionBox>
            
              <More
                key={`select-${data._id}`}
                className="selected-privilege"
              >
                {/* <FormInput placeholder={""} key={`input` + slNo} id={data._id} index={slNo} value={selectedValue[data._id] && selectedValue[data._id]} type="checkbox" onChange={handleSelectedValue} />  */}
                <Checkbox theme={themeColors} checked={selectedValue[data._id] && selectedValue[data._id]} onChange={(event) => setSelectedValue({...selectedValue, [data._id]: event.target.checked})} className="medium"></Checkbox>
              </More>
          </ActionBox>
        </Td>)}
        {attributes.map((attribute, index) => {
          let itemValue;
          if (attribute.type === "expired" && attribute.showItem === "contractEnd") {
            if (data.contractEnd === null && data.contractFrom !== null) {
                itemValue = new Date(data.contractFrom) <= new Date() ? new Date(new Date().setDate(new Date().getDate() + 1)) : null;
            } else if (data.contractEnd === null && data.contractFrom === null) {
                itemValue = new Date(new Date().setDate(new Date().getDate() + 1));
            } else {
              itemValue = new Date(data.contractEnd) >= new Date() ? new Date(data.contractEnd) : null;
            }
          } else if (attribute.collection?.length > 0 && attribute.showItem?.length > 0) {
            itemValue = data[attribute.collection]?.[attribute.showItem];
          } else {
            itemValue = data[attribute.name];
          }
          let type = attribute.type;
          if (attribute.view === true) {
            if (attribute.type === "mixed") {
              type = data["fieldType"];
            }
            if (attribute.type === "select" && attribute?.showItem === "locale") {
              itemValue = attribute.showItem?.length > 0 ? data[attribute.name]?.[selectedLanguage] ?? "" : data[attribute.name];
              return (
                <Td onClick={openRowData} key={index}>
                  {t(itemValue)}
                </Td>
              );
            }
            try {
              if (itemValue?.length === 0) {
                return (
                  <Td onClick={openRowData} key={index}>
                    {t(`na`)}
                  </Td>
                );
              }
              switch (type) {
                case "translate":
                  return (
                    <Td onClick={openRowData} key={index}>
                      {t(itemValue)}
                    </Td>
                  );
                case "text":
                case "view":
                  return (
                    <Td onClick={openRowData} key={index}>
                      {itemValue?.startsWith("http") ? <a style={{color: '#55188b'}} href={itemValue} target="_blank" rel="noopener noreferrer">{itemValue}</a> : t(itemValue)}
                    </Td>
                  );
                case "minute":
                  return (
                    <Td onClick={openRowData} key={index}>
                      {convertMinutesToHHMM(parseFloat(itemValue ?? 0))}
                    </Td>
                  );
                case "image":
                  return (
                    <Td onClick={openRowData} key={index}>
                      {/* <Img src={`https://d2ko9fbemypq1w.cloudfront.net/${parent[attribute.name]}`} /> */}
                    </Td>
                  );
                case "file":
                  return (
                    <Td key={index} onClick={openRowData}>
                      <div
                        style={{ width: "20px", cursor: "pointer" }}
                        onClick={(e) => {
                          e.preventDefault(); // Prevent the default link behavior
                          const link = document.createElement("a");
                          link.href = process.env.REACT_APP_CDN + itemValue;
                          link.target = "_blank"; // Open in a new page/tab
                          link.download = ""; // You can set the desired download filename here
                          link.style.display = "none";
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        }}
                      >
                        <GetIcon icon={"Download"}></GetIcon>
                      </div>
                    </Td>
                  );

                case "datetime":
                  let userFriendlyDateTime = itemValue ? shortName==="caseReports" ? attribute.name==="updatedAt" && moment(data["updatedAt"]).isSame(moment(data["createdAt"])) ? dateTimeFormat(itemValue) : dateFormat(itemValue) : dateTimeFormat(itemValue) : "N/A";
                  return (
                    <Td onClick={openRowData} key={index}>
                      {userFriendlyDateTime}
                    </Td>
                  );
                case "icon":
                  return (
                    <Td key={index} className={itemValue}>
                      <GetIcon onClick={openRowData} icon={itemValue}></GetIcon>
                    </Td>
                  );
                case "date":
                  let userFriendlyDate = itemValue ? dateFormat(itemValue) : "N/A";
                  return (
                    <Td onClick={openRowData} key={index}>
                      {userFriendlyDate}
                    </Td>
                  );
                case "age":
                    // Calculate age in years from the date
                    let age = "N/A";
                    if (itemValue) {
                    const birthDate = new Date(itemValue);
                    if (!isNaN(birthDate.getTime())) {
                      const today = new Date();
                      let years = today.getFullYear() - birthDate.getFullYear();
                      const m = today.getMonth() - birthDate.getMonth();
                      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                      years--;
                      }
                      age = years;
                    }
                    }
                    return (
                    <Td onClick={openRowData} key={index}>
                      {age}
                    </Td>
                    );
                case "expired":
                  let status;
                  console.log("type: ", typeof itemValue)
                    if(attribute.name==="contractEnd" && data.userType && data.authorisation && data.authorisation.toLowerCase() === "admin"){
                      status = <Status color={"green"}>{t("active")}</Status>;
                    }
                    else if (typeof itemValue === 'string') {
                      // Check if it's a valid date string
                      const dateObj = new Date(itemValue);
                      if (!isNaN(dateObj.getTime())) {
                        // Compare only the date part, ignore time
                        const today = new Date();
                        today.setHours(0, 0, 0, 0);
                        dateObj.setHours(0, 0, 0, 0);
                        status = dateObj >= today
                        ? <Status color={"green"}>{t("active")}</Status>
                        : <Status color={"red"}>{t("inactive")}</Status>;
                      } else {
                        // Handle string cases ("open" or "close")
                        if (itemValue.toLowerCase() === 'new') {
                          status = <Status color={"#3498DB"}>{t("new")}</Status>;
                        } else if (itemValue.toLowerCase() === 'open') {
                          status = <Status color={"green"}>{t("open")}</Status>;
                        } else if (itemValue.toLowerCase() === 'close') {
                          status = <Status color={"red"}>{t("close")}</Status>;
                        } else if (itemValue.toLowerCase() === 'in_progress') {
                          status = <Status color={"#ecec00"}>{t("In progress")}</Status>;
                        } else {
                          status = "";
                        }
                      }
                    } else if (typeof itemValue === 'boolean') {
                       itemValue
                      ? status = <Status color={"green"}>{t("active")}</Status>
                      : status = <Status color={"red"}>{t("inactive")}</Status>;
                    } else if (itemValue instanceof Date || !isNaN(new Date(itemValue))) {
                    // Handle date cases
                    status = new Date(itemValue) > new Date()
                      ? <Status color={"green"}>{t("active")}</Status>
                      : <Status color={"red"}>{t("inactive")}</Status>;
                    } else {
                    // Handle null/undefined or other cases
                    status = <Status color={"red"}> {t(attribute.ifNull)}</Status>;
                    }

                  return (
                    <Td onClick={openRowData} key={index}>
                      {status}
                    </Td>
                  );
                case "time":
                  return (
                    <Td onClick={openRowData} key={index}>
                      {itemValue ? timeFormat(itemValue) : "N/A"}
                    </Td>
                  );
                case "color":
                  return (
                    <Td onClick={openRowData} key={index}>
                      <div style={{ backgroundColor: itemValue, height: "20px", width: "40px" }}></div>
                    </Td>
                  );
                case "textarea":
                  return <Td onClick={openRowData} key={index} dangerouslySetInnerHTML={{ __html: data[attribute.name]?.length > 130 ? (data[attribute.name]?.substring(0, 130) + "...") : data[attribute.name] }}></Td>;
                case "checkbox":
                  return (
                    <Td onClick={openRowData} key={index}>
                      {shortName==="whistleCategory" ? <div style={{display:'flex', alignItems:'center', gap:'5px'}}>{itemValue ? <><GetIcon fontSize="14" color="green" icon={"correct"} />{t("active")}</> : <><GetIcon fontSize="16" icon={"wrong"}/>{t("inactive")}</>}</div> : <IconBox className={"display"}>{itemValue ? <GetIcon icon={"checked"} /> : <GetIcon icon={"Close"} />}</IconBox>}
                    </Td>
                  );

                case "select":
                  if (attribute.apiType === "JSON") {
                    console.log(api,attribute.name)
                    const item = attribute.selectApi
                      .filter((item) => item.id.toString() === data[attribute.name]?.toString())
                      .map((filteredItem, index) => (
                        <Td onClick={openRowData} style={{ color: filteredItem.color }} key={index}>
                          {(api.includes("emp_dev_feedback") && attribute.name==="status" && (filteredItem?.value?.toLowerCase()==="submitted" || filteredItem?.value?.toLowerCase()==="eingereicht")) ? <span style={{color: "green"}}>{t("submitted")}</span> : t(filteredItem.value)}
                        </Td>
                      ));
                    return item.length > 0 ? item : <Td>{t(`na`)}</Td>;
                  } else if (attribute.apiType === "CSV") {
                    return (
                      <Td onClick={openRowData} key={index}>
                        {data[attribute.name] ?? "Nil"}
                      </Td>
                    );
                  } else {
                    return (
                      <Td onClick={openRowData} key={index}>
                        {t(data[attribute.name]?.[attribute.showItem==="locale" ? selectedLanguage : attribute.showItem] ?? "Nil")}
                      </Td>
                    );
                  }

                  case "multiSelect":
                  if (attribute.apiType === "JSON") {
                    const item = attribute.selectApi
                      .filter((item) => item.id.toString() === data[attribute.name]?.toString())
                      .map((filteredItem, idx) => (
                        <Td onClick={openRowData} style={{ color: filteredItem.color }} key={`${index}-${idx}`}>
                          {t(filteredItem.value)}
                        </Td>
                      ));
                    return item.length > 0 ? item : <Td key={index}>N/A</Td>;
                  } else if (attribute.apiType === "CSV") {
                    return (
                      <Td onClick={openRowData} key={index}>
                        {data[attribute.name] ?? "Nil"}
                      </Td>
                    );
                  } else {
                    return (
                      <Td onClick={openRowData} key={index}>
                        {data[attribute.name]?.map((val,idx)=> {
                          if(idx===data[attribute.name]?.length-1){
                            return t(val[attribute.showItem==="locale" ? selectedLanguage : attribute.showItem] ?? "Nil")
                          }
                          else{
                            return t(val[attribute.showItem==="locale" ? selectedLanguage : attribute.showItem] ?? "Nil")+", "
                          }
                         }) }
                      </Td>
                    );
                  }
                default:
                  switch (typeof data[attribute.name]) {
                    case "undefined":
                      return (
                        <Td onClick={openRowData} key={index}>
                          {t(`na`)}
                        </Td>
                      );
                    case "object":
                    case "objectId":
                      return (
                        <Td onClick={openRowData} key={index}>
                          {objectValueReturn(data, attribute)}
                        </Td>
                      );
                    case "boolean":
                      return (
                        <Td onClick={openRowData} key={index}>
                          {data[attribute.name].toString()}
                        </Td>
                      );
                    case "string":
                    case "number":
                    default:
                      if (attribute.type === "select" && attribute.showItem === "locale") {
                        return (
                          <Td onClick={openRowData} key={index}>
                            {data[attribute.name][sessionStorage.getItem("language") ?? "de"]}
                          </Td>
                        );
                      } else if (attribute.type === "select" && attribute.apiType === "JSON") {
                        const item = attribute.selectApi
                          .filter((item) => item.id.toString() === data[attribute.name]?.toString())
                          .map((filteredItem, idx) => (
                            <Td onClick={openRowData} style={{ color: filteredItem.color }} key={`JSON-${index}-${idx}`}>
                              {t(filteredItem.value)}
                            </Td>
                          ));
                        // console.log(attribute.naneitem);
                        return item ?? <Td key={index}>{t(`na`)}</Td>;
                      } else {
                        
                        return (
                          <Td onClick={openRowData} key={index}>
                            {data[attribute.name]?.toString().substring(0, 200)}
                          </Td>
                        );
                      }
                  }
              }
            } catch (error) {
              console.log(error);
              if (type === "expired") {
                return (
                  <Td onClick={openRowData} key={index}>
                    <Status color={"red"}> {t(attribute.ifNull ?? "N/A")}</Status>
                  </Td>
                );
              } else {
                return <Td key={index} onClick={openRowData}>{t(`na`)}</Td>;
              }
            }
          } else {
            return null;
          }
        })}
        <Td key={`actions-${shortName}-${data._id}`} style={{ zIndex: (pinnedRows === true ? count * 2 : count) + 100 - slNo }} className="actions">
          <ActionBox>
            {updatePrivilege && shortName!=="caseReports" && (data?.isMasterData ? (shortName==="whistleCategory" || user?.data?.user?.authorisation?.toLowerCase()==="super") : true) && (
              <More
                key={`edit-${data._id}`}
                onClick={() => isEditingHandler(data, udpateView)}
                className="edit"
              >
                <GetIcon icon={"edit"} />
              </More>
            )}
            {delPrivilege && shortName === "forms" && (
              <More
              key={`delete-${data._id}`}
              onClick={() => {
                setMessage({
                  type: 2,
                  content: t("deleteRequest", { label: data[itemTitle] ? data[itemTitle].toString() : "Item" }),
                  proceed: t("delete"),
                  onProceed: deleteHandler,
                  data: data,
                  });
                }}
                className="delete"
              >
                <GetIcon icon={"delete"} />
              </More>
            )}

            {actions.map((item,idx) => {
              return (
                item.element !== "button" && shortName !== "caseReports" &&
                (item.element === "toggle" ? (
                  <ToggleContainer key={`${item.id}-${data._id}-${idx}`}>
                    <ToggleInput
                      type="checkbox"
                      checked={data[item.id]}
                      onChange={async (event) => {
                        // item.callback(item, data);
                        setLoaderBox(true);
                        await postData({ status: event.target.checked }, `${item.api}/${data._id}`, dispatch, navigate)
                          .then((response) => {
                            if (response.status === 200) {
                              if (response.data?.message) {
                                setMessage({ type: 1, content: t(response.data?.message), proceed: t("okay"), code: 200 });
                              }
                              //
                              refreshView();
                              // setIsEditing(false);
                            } else if (response.status === 404) {
                              refreshView();
                              setMessage({ type: 1, content: t("error"), proceed: "Okay", code: 404 });
                            } else {
                              refreshView();
                              setMessage({ type: 1, content: t("error"), proceed: "Okay", code: 500 });
                            }
                            // setLoaderBox(false);
                          })
                          .catch((error) => {
                            alert(error);
                            // setLoaderBox(false);
                          });
                      }}
                    />
                    <ToggleSlider />
                  </ToggleContainer>
                ) : (
                  <More
                    key={`${slNo}-action-new`}
                    onClick={() => {
                      if (item.type === "callback") {
                        item.callback(item, data, refreshView);
                      } else if (item.type === "call") {
                        window.location.href = `tel:${data.mobileNumber}`;
                      } else if (item.type === "subList") {
                        setSubAttributes({ item, data });
                        setShowSubList(true);
                      } else {
                        openAction(item, data);
                      }
                    }}
                  >
                    <GetIcon icon={item.icon}></GetIcon>
                  </More>
                ))
              );
            })}
            {viewDetails === true && (
              <More onClick={openRowData}>
                <GetIcon icon={"open"}></GetIcon>
              </More>
            )}
            <div
              ref={selectRef.current[slNo]}
              onClick={() => {
                setCurrentAction(slNo);
              }}
            >
              {acctionCount > 0 && (
                <>
                  <More className={currentAction === slNo ? `active` : ``}>
                    <GetIcon icon={"dots"}></GetIcon>
                  </More>

                  <ToolTip className={currentAction === slNo ? `actions` : `actions hide`}>
                    <Actions>
                      {actions.map((item) => {
                        return (
                          item.element === "button" && (
                            <Button
                              key={`custom-${item.id}-${data._id}`}
                              onClick={() => {
                                if (item.type === "callback") {
                                  item.callback(item, data);
                                } else if (item.type === "call") {
                                  window.location.href = `tel:${data.mobileNumber}`;
                                } else if (item.type === "subList") {
                                  setSubAttributes({ item, data });
                                  setShowSubList(true);
                                } else {
                                  openAction(item, data);
                                }
                              }}
                              className="edit"
                            >
                              <GetIcon icon={item.icon} />
                              <span>{t(item.title)}</span>
                            </Button>
                          )
                        );
                      })}
                    </Actions>
                  </ToolTip>
                </>
              )}
            </div>
          </ActionBox>
        </Td>
        {data?.requestDocs && !data?.file && reqDoc && <Td key={`actions-${shortName}-${data._id}`} style={{ zIndex: (pinnedRows === true ? count * 2 : count) + 100 - slNo }}>
          <ActionBox onClick={() => {
                  isEditingHandler(data, udpateView);
                }}
                className="edit" style={{color:'red'}}>
            Request
          </ActionBox>
        </Td>}
      </Tr>
    );
  };
  const closeModal = () => {
    setShowSubList(false);
  };
  const [searchValue, setSearchValue] = useState("");
  const [filter, setFilter] = useState(false);
  const searchTimeoutRef = useRef();
  const handleChange = (event) => {
    clearTimeout(searchTimeoutRef.current);
    setSearchValue(event.target.value);
    searchTimeoutRef.current = setTimeout(() => {
      setFilterView({ ...filterView, searchkey: event.target.value });
    }, 300);
  };
  useEffect(() => {
    return () => {
      clearTimeout(searchTimeoutRef.current);
    };
  }, []);
  const selectRef = useRef([]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedInsideRefs = selectRef.current.filter((ref) => ref.current && ref.current.contains(event.target));

      if (clickedInsideRefs.length === 0) {
        setCurrentAction("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const selectedMenu = useSelector((state) => state.selectedMenu);
  const [exportPopup, setExportPopup] = useState(false);
  const [exportAttributes, setExportAttributes] = useState({});

  const fetchChartData = (dispatch, navigate) =>
    getData({}, chart, dispatch, navigate);


  const handleFormSubmission = async (payload) => {
    try {
      const data = {
        response: payload,
        id: openData?.data?._id
      }

      console.log(data);
      setLoaderBox(true);
    await postData(data, `${api}/submit`, dispatch, navigate)
      .then((response) => {
        if (response.status === 200) {
          // setMessage({ type: 1, content: `The '${t(shortName)}' saved successfully!`, proceed: "Okay" });
            setMessage({ type: 1, content: t("saved", { shortName: (t(shortName)==="Abwesenheiten" && window.location.pathname==="/settings") ? "Abwesenheit" : t(shortName)}), proceed: "Okay", code: 200 });
          if(setRefreshVal)
            setRefreshVal(true);
          refreshView();
          setLoaderBox(false);
          setShowDetails(false);
          return true;
          // udpateView(0);
        } else if (response.status === 404) {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 404 });
          setLoaderBox(false);
          return false;
        } else {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 500 });
          setLoaderBox(false);
          return false;
        }
      })
      .catch((error) => {
        setMessage({ type: 1, content: error.message + "Something went wrong!", proceed: "Okay", code: 500 });
        setLoaderBox(false);
        return false;
      });
    } catch (error) {
      return false;
    }
  }

  return (
    <RowContainer className={`list ${listHeadClass??""} ${cases ? "cases" : ""}`}>
      {(page && page==="profile") ? !display && <Title className="inner">
        <GetIcon icon={shortName}></GetIcon>
        {t(shortName)}
      </Title>:
      !display && <Title className="inner">
        <GetIcon icon={selectedMenu.icon}></GetIcon>
        {location.pathname.includes("/report/") ? t("report") + " - " + t(shortName) : t(selectedMenu.label)}
      </Title>}
      {location.pathname.includes("/report/") && <AddButton onClick={() => navigate(-1)} style={{cursor:'pointer',margin:'-5px auto 5px 5px', color:'#000000', display:'flex', alignItems:'center', gap:'2px'}}><GetIcon icon={"left-arrow"} color="#000000" fontSize="25px"/>{t("back")}</AddButton>}
      {(display || removeButtonPannel) ? null : <ButtonPanel className={`${groupedData?.length>0?"groupedData":""}`}>
        <FilterBox>
          <Search theme={themeColors} placeholder="Search" value={searchValue} onChange={handleChange}></Search>
          {filter && (
            <Filter
              theme={themeColors}
              onClick={() => {
                refreshView(currentIndex);
              }}
            >
              <GetIcon icon={"reload"} />
            </Filter>
          )}
          <Filter
            theme={themeColors}
            onClick={() => {
              let val = {};
              attributes.map((attribute) => attribute.view === true ? val[attribute.name] = true : attribute)
              setExportAttributes(val)
              setMessage({ type: 2, content: t("export"), proceed: t("exportNow"), onProceed: toExcel, data: currentIndex });
            }}
          >
            <ExcelIcon />
          </Filter>
          {datefilter && <DateRangeSelector onChange={dateRangeChange} themeColors={themeColors} default="month"  ></DateRangeSelector>}
        </FilterBox>
        <Filters className="right">
        {/* {(bulkUplaod ? bulkUplaod : false) && (
          <AddButton onClick={() => setShowBulkUplad((prev) => !prev)}>
            <UploadIcon></UploadIcon>
            <span>{t("bulkUpload", { label: t(shortName) })}</span>
          </AddButton>
        )} */}
        {((addPrivilege && !moreOptions) ? true : false) && (
          <AddButton style={{marginLeft:0}} onClick={() => isCreatingHandler(true, refreshView)}>
            <AddIcon></AddIcon>
            <span>{t("addNew", { label: t(shortName) })}</span>
          </AddButton>
        )}
        {(moreOptions ? moreOptions : false) && (
          <AddButton className="more">
            <AddIcon></AddIcon>
            <div style={{ display: "none" }}>
            {(addPrivilege ? addPrivilege : false) && (
              <AddButton style={{marginLeft:0}} onClick={() => isCreatingHandler(true, refreshView)}>
                <AddIcon fontSize={18} color={"#ffffff"}></AddIcon>
                <span>{t("addNew", { label: t(shortName) })}</span>
              </AddButton>
              )}
              <AddButton style={{marginLeft:0}} onClick={() => {}} >{t("sendMail")}</AddButton>
              {/* <AddButton onClick={() => setShowBulkUplad((prev) => !prev)}>{t("bulkUpload")}</AddButton> */}
              <AddButton style={{marginLeft:0}} 
            onClick={()=> {
              let val = {};
              attributes.map((attribute) => attribute.view === true ? val[attribute.name] = true : attribute)
              setExportAttributes(val)
              setExportPopup(true)
            }}
            >{t("exportExcel")}</AddButton>
            </div>
          </AddButton>
        )}
        
          {formInput.filter((item) => item.type === "select" && (item.filter ?? true) === true)?.length>0 && <AddButton onClick={()=> setShowDrawer(true)}>
            <FilterIcon fontSize={18}></FilterIcon>
            <span>{t("filter")}</span>
          </AddButton>}
          {/* {formInput.map((item, index) => {
            return item.type === "select" && (item.filter ?? true) === true && <FormInput customClass={"filter"} placeholder={item.placeHolder} value={filterView[item.name]} key={`input` + index} id={item.name} {...item} type={item.filterType ?? "multiSelect"} onChange={filterChange} />;
          })} */}
        </Filters>
      </ButtonPanel>}
      {chart && <DynamicBarChart t={t} fetchData={fetchChartData} transformData={transformData} title={shortName} />}
        {cases && <CasesContainer>
          <CaseItem>
            <div className="num">{users?.data?.cases?.totalCase}</div>
            <div>{t("Total Cases")}</div>
          </CaseItem>
          <CaseItem>
            <div className="num">{users?.data?.cases?.newCase} / {users?.data?.cases?.totalCase}</div>
            <div>{t("New case")}</div>
          </CaseItem>
          <CaseItem>
            <div className="num">{users?.data?.cases?.openCase} / {users?.data?.cases?.totalCase}</div>
            <div>{t("Open case")}</div>
          </CaseItem>
          <CaseItem>
            <div className="num">{users?.data?.cases?.closedCase}</div>
            <div>{t("Closed case")}</div>
          </CaseItem>
        </CasesContainer>}
            {/* <thead></thead> */}
            {!display && groupedData?.length > 0 ? shortName==="whistleCategory" ? 
            (
              groupedData.map((group,index) => {

                return (
                  <>
                    {index===1 && <GroupHeader onClick={()=> setEnabledInAktCategory(!enabledInAktCategory)} key={index} index={index} className={"hideDisableCategory"}>
                      <GetIcon fontSize="20" icon={enabledInAktCategory ? "hide" : "show"}></GetIcon>
                      {enabledInAktCategory ? t("hideDisableCategory") : t("showDisableCategory")}
                    </GroupHeader>}
                    {(index===1 ? enabledInAktCategory : true) && <ScrollContainerLayout key={index} index={index}>
                    <ScrollLayout className="groupList">
            
                      <Table>
                      <thead>
                        <Tr className="no-border">
                        {selectPrivilege && <ActionBox>
                            <More
                              key={`select-${data._id}`}
                              className="selected-privilege"
                            >
                              {/* <FormInput placeholder={""} key={`input` + 0} id={data._id} index={0} value={group.items?.filter((item)=> !selectedValue[item._id]).length<=0} type="checkbox" onChange={(sl, event)=> {
                                let value = {};
                                group.items?.map((item)=> value[item._id]=event);
                                setSelectedValue(value)
                              }} />  */}
                              <Checkbox theme={themeColors} checked={data?.filter((item)=> !selectedValue[item._id]).length<=0} onChange={(event) => {
                                let value = {};
                                data?.map((item)=> value[item._id]=event.target.checked);
                                setSelectedValue(value)
                              }} className="medium"></Checkbox>
                            </More>
                        </ActionBox>}
                          {attributes.map((attribute, index) => {
                            return attribute.view === true ? <Th key={shortName + attribute.name + index}>{t(attribute.label)}</Th> : "";
                          })}
                        </Tr>
                      </thead>
                      <tbody>
                        {group.items?.map((item, index) => (
                          <React.Fragment key={`${shortName}-${index}`}>
                            <TableRowWithActions slNo={index} attributes={attributes} data={item} pinnedRows={false} />
                          </React.Fragment>
                        ))}
                      </tbody>
                    </Table>
                    </ScrollLayout>
                    </ScrollContainerLayout>}
                  </>
                );
              })
            )
            :(
              groupedData.map((group,index) => {
                return (
                  <>
                    <GroupHeader key={index} index={index} className={group.status}>
                      <GetIcon icon={group.status}></GetIcon>
                      {t(group.status)}
                    </GroupHeader>
                    <ScrollContainerLayout key={index} index={index}>
                    <ScrollLayout className="groupList">
            
                      <Table>
                      <thead>
                        <Tr className="no-border">
                        {selectPrivilege && <ActionBox>
                            <More
                              key={`select-${data._id}`}
                              className="selected-privilege"
                            >
                              {/* <FormInput placeholder={""} key={`input` + 0} id={data._id} index={0} value={group.items?.filter((item)=> !selectedValue[item._id]).length<=0} type="checkbox" onChange={(sl, event)=> {
                                let value = {};
                                group.items?.map((item)=> value[item._id]=event);
                                setSelectedValue(value)
                              }} />  */}
                              <Checkbox theme={themeColors} checked={data?.filter((item)=> !selectedValue[item._id]).length<=0} onChange={(event) => {
                                let value = {};
                                data?.map((item)=> value[item._id]=event.target.checked);
                                setSelectedValue(value)
                              }} className="medium"></Checkbox>
                            </More>
                        </ActionBox>}
                          {attributes.map((attribute, index) => {
                            return attribute.view === true ? <Th key={shortName + attribute.name + index}>{t(attribute.label)}</Th> : "";
                          })}
                        </Tr>
                      </thead>
                      <tbody>
                        {group.items?.map((item, index) => (
                          <React.Fragment key={`${shortName}-${index}`}>
                            <TableRowWithActions slNo={index} attributes={attributes} data={item} pinnedRows={false} />
                          </React.Fragment>
                        ))}
                      </tbody>
                    </Table>
                    </ScrollLayout>
                    </ScrollContainerLayout>
                  </>
                );
              })
            ) : (
              !display && <ScrollContainerLayout>
        <ScrollLayout>
              <table>
                <thead>
                  <Tr className="head no-border">
                  {selectPrivilege && <Th> <ActionBox>
                          <More
                            key={`select`}
                            className="selected-privilege"
                          >
                            {/* <FormInput placeholder={""} key={`input` + 0} id={0} index={0} value={data?.filter((item)=> !selectedValue[item._id]).length<=0} type="checkbox" onChange={(sl, event)=> {
                              let value = {};
                              data?.map((item)=> value[item._id]=event);
                              setSelectedValue(value)
                            }} />  */}
                            <Checkbox theme={themeColors} checked={data?.filter((item)=> !selectedValue[item._id]).length<=0} onChange={(event) => {
                              let value = {};
                              data?.map((item)=> value[item._id]=event.target.checked);
                              setSelectedValue(value)
                            }} className="medium"></Checkbox>
                          </More>
                      </ActionBox></Th>}
                    {attributes.map((attribute, index) => {
                      // console.log(attribute.view === true ? `${attribute.label} - ${t(attribute.name)}` : "");
                      // console.log("selected language: " + t("Add New Equipments"));
                      return attribute.view === true ? <Th key={shortName + attribute.name + index}>{t(attribute.label)}</Th> : "";
                    })}
                  </Tr>
                </thead>
                <tbody>
                  {data?.length > 0 &&
                    data.map((item, index) => (
                      <React.Fragment key={`${shortName}-${index}`}>
                        <TableRowWithActions slNo={index} attributes={attributes} data={item} pinnedRows={false} />
                      </React.Fragment>
                    ))}
                </tbody>
              </table>
                {groupedData?.length > 0 ? null : ((!chart && (!users.data || !users.data?.data || users.data?.data.length === 0)) || (chart && (!data || data.length===0))) && <NoData>{t("notFound", { page: t(shortName) })}</NoData>}
              </ScrollLayout>
              </ScrollContainerLayout>
            )}
          
      {!display && count > currentLimit ? (
        <Filters className="full">
          <Count>
            <ArrowButton
              theme={themeColors}
              onClick={() => {
                setCurrentIndex((prev) => (prev > 9 ? prev - (currentLimit === 0 ? count : currentLimit) : 0));
              }}
            >
              <PreviousIcon />
            </ArrowButton>
            {t("showing", {
              from: currentIndex + 1,
              to: Math.min(currentIndex + (currentLimit === 0 ? count : currentLimit), count),
              count: count,
            })}
            <ArrowButton
              theme={themeColors}
              onClick={() => {
                setCurrentIndex((prev) => (prev + 10 > count ? currentIndex : currentIndex + (currentLimit === 0 ? count : currentLimit)));
              }}
            >
              <NextIcon />
            </ArrowButton>
          </Count>
          <FormInput customClass={"filter records"} placeholder={`show`} value={currentLimit} key={`input0`} id={"itemsPage"} {...pageLimitFilter} onChange={pageLimitFilterChange} />
        </Filters>
      ) : groupedData?.length > 0 ? null : (
        !display && <Filters theme={themeColors} className="full">
          {count === 0 ? <Count></Count> : <Count>{t("showingData", { count ,records: location.pathname==="/employees"? t("Employees"): location.pathname==="/team" ? (count === 1 ? t("Person") : t("Persons")): location.pathname==="/news" ? (count === 1 ? t("message") : t("messages")) : t("Entries")})}</Count>}
        </Filters>
      )}
      {display && <DisplayInformations udpateView={udpateView} isEditingHandler={dataVal ? isEditingHandler : isCreatingHandler} actions={actions} refresh={refreshView} setMessage={setMessage} setLoaderBox={setLoaderBox} profileImage={profileImage} formMode={formMode} formView={formView} attributes={attributes} data={dataVal} display={display} tabName={shortName} />}
      {showDetails && (
        <PopupView
          // Popup data is a JSX element which is binding to the Popup Data Area like HOC
          popupData={
            (shortName==="EmpFeedback") ? <div style={{ display:'flex', justifyContent:'center'}}><ResponsesViewer form={openData?.data?.form} response={openData?.data?.status==="submitted" ? openData?.data?.response : null} /> </div>

            : (shortName==="forms" || shortName==="feedbackForm") ? <div style={{ display:'flex', justifyContent:'center'}}><FormViewer form={shortName==="feedbackForm" ? openData?.data?.form : openData?.data} handleFormSubmission={api==="emp_dev_feedback/employee"? handleFormSubmission : false} showAlert={(val) => setMessage({ type: 1, content: t(val), proceed: "Okay", code: 404 })} response={openData?.data?.status==="submitted" ? openData?.data?.response : null} /> </div>

            : <DisplayInformations udpateView={udpateView} isEditingHandler={isEditingHandler} actions={actions} refresh={refreshView} setMessage={setMessage} setLoaderBox={setLoaderBox} profileImage={profileImage} formMode={formMode} formView={formView} attributes={attributes} data={openData.data} api={api} shortName={shortName} whistleblowing={shortName==="caseReports" ? <CrudForm delPrivilege={delPrivilege} formMode="double" deleteHandler={deleteHandler} setMessage={setMessage} formView={formView} api={api} formType={"put"} updateId={updateId} header={t("update", { label: t(shortName ? shortName : "Form") })} shortName={shortName} formInput={formInput} formErrors={errroInput} formValues={updateValues} submitHandler={updateHandler} isOpenHandler={(val) => {
            setShowDetails(val);
            isEditingHandler(val);
          }} isOpen={isEditing} actions={actions} setLoaderBox={setLoaderBox} setRefreshVal={setRefreshVal} refreshView={refreshView} openData={openData} plainForm="plain" ></CrudForm> : null} />
        }
          themeColors={themeColors}
          closeModal={() => {
            setShowDetails(false);
            if(searchParams.get("id")){
              searchParams.delete("id");
              setSearchParams(searchParams);
            }
          }}
          setMessage={setMessage}
          setLoaderBox={setLoaderBox}
          profileImage={profileImage}
          itemTitle={typeof itemTitle === "string" ? { name: itemTitle, type: "text" } : itemTitle}
          openData={openData} // Pass selected item data to the popup for setting the time and taking menu id and other required data from the list item
          customClass={(shortName==="feedbackForm") ? "feedbackForm medium" : shortName==="caseReports" ? 'large' : formView}
        ></PopupView>
      )}
      {exportPopup && (
        <PopupView
          // Popup data is a JSX element which is binding to the Popup Data Area like HOC
          popupData={<ExportPopupData attributes={attributes} t={t} themeColors={themeColors} selectedValue={exportAttributes} setSelectedValue={setExportAttributes} />}
          themeColors={themeColors}
          closeModal={() => {
            setExportPopup(false);
          }}
          setMessage={setMessage}
          setLoaderBox={setLoaderBox}
          profileImage={profileImage}
          itemTitle={t("exportExcel")}
          actionButton={true}
          actionFunction={() => setMessage({ type: 2, content: t("export"), proceed: t("exportNow"), onProceed: toExcel, data: currentIndex })}
          actionButtonName="exportExcel"
        ></PopupView>
      )}
      {isCreating && <CrudForm formMode={formMode} formView={formView} api={api} formType={"post"} header={t("addNewTitle", { label: t(shortName ? shortName : "Form") })} shortName={shortName} formInput={formInput} formValues={addValues} formErrors={errroInput} submitHandler={submitHandler} isOpenHandler={isCreatingHandler} isOpen={isCreating} openData={users?.data?.data?.length>0 ? {data: users.data.data[0]} : false} ></CrudForm>}
      {isEditing && <CrudForm delPrivilege={delPrivilege} deleteHandler={deleteHandler} setMessage={setMessage} formMode={formMode} formView={formView} api={api} formType={"put"} updateId={updateId} header={t("update", { label: t(shortName ? shortName : "Form") })} shortName={shortName} formInput={formInput} formErrors={errroInput} formValues={updateValues} submitHandler={updateHandler} isOpenHandler={isEditingHandler} isOpen={isEditing} actions={actions} setLoaderBox={setLoaderBox} setRefreshVal={setRefreshVal} refreshView={refreshView} openData={openData} ></CrudForm>}
      {action.data && <Manage setMessage={setMessage} setLoaderBox={setLoaderBox} onClose={closeManage} {...action}></Manage>}
      {bulkUplaod && showBulkUplad && (
        <CrudForm
          bulkUpload={true}
          delPrivilege={delPrivilege}
          deleteHandler={deleteHandler}
          setMessage={setMessage}
          setLoaderBox={setLoaderBox}
          formMode={"single"}
          formView={formView}
          api={api}
          formType={"put"}
          updateId={updateId}
          header={t("bulkUpload", { label: t(shortName ? shortName : "Form") })}
          formInput={formInput}
          formErrors={errroInput}
          formValues={updateValues}
          currentApi={currentApi}
          submitHandler={() => {
            refreshView(currentIndex);
            setIsEditing(false);
            setShowBulkUplad(false);
          }}
          isOpenHandler={() => setShowBulkUplad(false)}
          isOpen={isEditing}
        ></CrudForm>
      )}
      {showLoader && <Loader></Loader>}
      {showSublist && subAttributes?.item?.attributes?.length > 0 && <SubPage closeModal={closeModal} setMessage={setMessage} setLoaderBox={setLoaderBox} subAttributes={subAttributes}></SubPage>}
      {showDrawer && <Drawer setShowDrawer={setShowDrawer} formInput={formInput} filterView={filterView} setFilterView={setFilterView} onChange={filterChange} />}
    </RowContainer>
  );
};
export default ListTable;

const ExportPopupData = ({attributes, t, themeColors, selectedValue, setSelectedValue}) => {

  return (
    <ExportPopupContainer>
      {attributes.map((attribute, index) => {
        return attribute.view === true ? 
        <div style={{display:'flex', alignItems:'center'}}>
          <Checkbox theme={themeColors} checked={selectedValue[attribute.name] && selectedValue[attribute.name]} onChange={(event) => setSelectedValue({...selectedValue, [attribute.name]: event.target.checked})} className="medium"></Checkbox>
          <div key={index}>{t(attribute.label)}</div> 
        </div>
        : null;
      })}
    </ExportPopupContainer>
  )
}
